'use client';
import Image from 'next/image';
import { useTheme } from 'next-themes';

export default function Loading() {
  const { theme } = useTheme();
  return theme === 'dark' ? (
    <Image width={0} height={0} className='w-1/3 m-auto animate-pulse' src={`/images/optima-logo-dark.svg`} alt='' />
  ) : (
    <Image width={0} height={0} className='w-1/3 m-auto animate-pulse' src={`/images/optima-logo-light.svg`} alt='' />
  );
}
